import React from "react";

export default function PhoneIcon() {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="44"
        height="44"
        rx="12"
        fill="url(#paint0_linear_872_600)"
        fillOpacity="0.08"
      />
      <path
        opacity="0.32"
        d="M28.6196 27V18.6667H15.2863V27C15.2863 28.8409 16.7787 30.3333 18.6196 30.3333H25.2863C27.1272 30.3333 28.6196 28.8409 28.6196 27Z"
        fill="url(#paint1_linear_872_600)"
      />
      <path
        d="M17.979 13.6667H25.9269C27.4414 13.6667 28.8033 14.704 29.3657 16.2859L29.9974 18.0624C30.1885 18.6002 30.3207 19.1756 30.1813 19.7291C29.851 21.0398 28.7795 22 27.5085 22C25.9744 22 24.7307 20.6009 24.7307 18.875C24.7307 20.6009 23.4871 22 21.953 22C20.4189 22 19.1752 20.6009 19.1752 18.875C19.1752 20.6009 17.9315 22 16.3974 22C15.1265 22 14.0549 21.0398 13.7246 19.7291C13.5852 19.1756 13.7173 18.6002 13.9086 18.0624L14.5402 16.2859C15.1027 14.704 16.4645 13.6667 17.979 13.6667Z"
        fill="url(#paint2_linear_872_600)"
      />
      <path
        d="M24.7598 26.7113C25.0605 26.5417 25.1668 26.1605 24.9973 25.8599C24.8278 25.5592 24.4467 25.4529 24.1459 25.6224C23.1982 26.1567 22.5522 26.3739 21.9528 26.3751C21.3547 26.3763 20.7087 26.1622 19.7619 25.6235C19.4619 25.4529 19.0803 25.5577 18.9097 25.8578C18.739 26.1578 18.8438 26.5394 19.1439 26.71C20.1605 27.2884 21.0344 27.6269 21.9552 27.6251C22.875 27.6234 23.7472 27.2822 24.7598 26.7113Z"
        fill="url(#paint3_linear_872_600)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_872_600"
          x1="44"
          y1="0.132743"
          x2="0"
          y2="44.1327"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7651FC" />
          <stop offset="0.512584" stopColor="#4591F5" />
          <stop offset="1" stopColor="#4EECE9" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_872_600"
          x1="28.6196"
          y1="18.7019"
          x2="17.0562"
          y2="31.9172"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7651FC" />
          <stop offset="0.512584" stopColor="#4591F5" />
          <stop offset="1" stopColor="#4EECE9" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_872_600"
          x1="30.2393"
          y1="13.7088"
          x2="16.484"
          y2="30.0402"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7651FC" />
          <stop offset="0.512584" stopColor="#4591F5" />
          <stop offset="1" stopColor="#4EECE9" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_872_600"
          x1="30.2393"
          y1="13.7088"
          x2="16.484"
          y2="30.0402"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7651FC" />
          <stop offset="0.512584" stopColor="#4591F5" />
          <stop offset="1" stopColor="#4EECE9" />
        </linearGradient>
      </defs>
    </svg>
  );
}
